import { Menu } from "antd";
import Sider from "antd/es/layout/Sider";
import styled from "styled-components";

// 菜单栏容器
export const MenuSider = styled(Sider)`
  flex: 0 0 250px !important;
  background: white !important;
  padding: 24px 10px;
  opacity: 1;
  .ant-menu-dark .ant-menu-submenu-selected > .ant-menu-submenu-title {
    background-color: #ebf4fe;
    color: #886dff;
  }
  .ant-menu-submenu-title:hover,
  .ant-menu-item:hover {
    background-color: #ebf4fe !important;
    color: #886dff !important;
  }
  .ant-menu-item-selected {
    background-color: #ebf4fe !important;
    color: #886dff !important;
  }
  .ant-menu-item-selected .ant-menu-title-content{
    color: unset;
    }
  .ant-menu-item:not(.ant-menu-item-selected):hover {
    background-color: #f5f4ff !important;
    color: #886dff !important;
  }
`;

// logo容器
export const Logo = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  overflow: hidden;
  margin: auto;
  margin-bottom: 0px;
`;

// 项目标题
export const Title = styled.h1<{
  collapsed: boolean;
}>`
  display: ${(props) => (props.collapsed ? "none" : "block")};
  overflow: hidden;
  width: 100%; // calc(100% - 70px)
  height: 60px;
  line-height: 60px;
  margin-bottom: 0;
  color: #444444;
  font-size: 18px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: 700;
  text-align: center;
`;

// logo图片
export const LogoImg = styled.div`
  width: 120px;
  height: 60px;
  /* background: url(${require("@/assets/img/home/logo.png")}); */
  background: url(${require("@/assets/img/home/bet.png")});
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
  margin: 0 10px;
  margin-left: 60px;
  border: none !important;
`;

// 菜单栏列表
export const MenuList = styled(Menu)`
  font-size: 16px;
  font-family: PingFang SC-粗体, PingFang SC;
  font-weight: 400;
  color: #444444;
  line-height: 22px;
  .ant-menu-sub.ant-menu-inline {
    background-color: transparent !important;
  }
  .ant-menu-title-content{
  color: #444444;
  }
  
`;
